import React from "react";
import "../styles/AddRole.css";
import BusinessHubHeader from "../components/BusinessHubHeader";
import BackArrow from "../icons/BusinessHub/BackArrow";
import RoleIcon from "../icons/BusinessHub/RoleIcon";
import DescriptionIcon from "../icons/BusinessHub/DescriptionIcon";
import { useState, useEffect, useRef } from "react";
import SearchIcon from "../icons/BusinessHub/SearchIcon";
import { useNavigate } from "react-router-dom";
import SuccTickIcon from "../icons/BusinessHub/SuccTickIcon";
import userController from "../controllers/userController";
import Utils from "../utils/Utils";
import { toast } from "react-toastify";
import { userService } from "../services/userService";

function AddRole() {
  const jwt = userService.getUser();
  const navigate = useNavigate();
  const [UserAdd, setUserAdded] = useState(false);
  const [data, setData] = useState([]);
  const [selected, setSelected] = useState([]);
  const [roledesc, setroledesc] = useState("");
  const [roleName, setroleName] = useState("");
  const [permID, setPermID] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const allChecked =
    data.length > 0 &&
    data.every((item) => selected.includes(item.permissionID));
  const toggleAll = (e) => {
    if (e.target.checked) {
      const allIDs = data.map((item) => item.permissionID);
      setSelected(allIDs);
      setPermID(allIDs);
    } else {
      setSelected([]);
      setPermID([]);
    }
  };
  const toggleOne = (permissionID) => {
    setSelected((prev) => {
      const updated = prev.includes(permissionID)
        ? prev.filter((x) => x !== permissionID)
        : [...prev, permissionID];

      setPermID(updated);
      return updated;
    });
  };
  // useEffect(() => {
  //   setjwt(userService.getUser());
  // }, []);

  useEffect(() => {
    try {
      const getData = async () => {
        const perm = await userController.GetAllPermission({
          jwt: jwt,
          application: 1,
        });
        setData(Array.isArray(perm?.data) ? perm.data : []);
      };
      getData();
    } catch (error) {
      console.log("error getting permisions");
    }
  }, [jwt]);

  const handleCreateRoll = async () => {
    const Pjwt = Utils.parseJwt(jwt);
    const companyID = userService.getCompID();

    const addRole = {
      companyId: companyID,
      permissionIDs: permID,
      roleDescription: roledesc,
      roleName: roleName,
    };
    try {
      const addRoleReq = await userController.AddRole({
        addRole: addRole,
        jwt: jwt,
      });
      if (addRoleReq.data && Utils.isSuccessResponse(addRoleReq)) {
        setUserAdded(true);
      }
      if (!addRoleReq.data && !Utils.isSuccessResponse(addRoleReq)) {
        toast.error(addRoleReq.response.data.message);
      }
    } catch (error) {
      console.log(error);
      console.log("err");
    }
  };

  const filteredData = data.filter((item) =>
    item.permissionName.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  return (
    <div className="new-role-screen-container">
      <div className="new-role-page-header">
        <BusinessHubHeader />
      </div>
      <div className="new-role-page-content">
        {UserAdd && (
          <div className="new-role-popup-container">
            <div
              className="new-role-popup-content-container"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="new-role-popup-content">
                <div className="new-role-successfully-added-icon">
                  <SuccTickIcon />
                </div>
                <div className="new-role-successfully-added-text">
                  Role Added Successfully
                </div>
                <div
                  className="new-role-successfully-added-action-button"
                  onClick={() =>
                    navigate("/user-management", {
                      state: { active: "C" },
                    })
                  }
                >
                  Continue
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="new-role-container">
          <div className="new-rol-container-header">
            <div className="new-role-header-nav">
              <div
                className="new-role-header-nav-icon"
                onClick={() =>
                  navigate("/user-management", {
                    state: { active: "C" },
                  })
                }
              >
                <BackArrow />
              </div>
              <div className="new-role-header-nav-text">
                Back to User Management
              </div>
            </div>
            <div className="new-role-header-title">Add Role</div>
          </div>
          <div className="new-role-container-body">
            <div className="new-role-body-cell">
              <div className="new-role-cell-header">
                <div className="add-new-role-header-role-selection">
                  <div className="add-new-role-select-role">
                    Role <div className="required">*</div>
                  </div>
                  <div className="add-new-role-select-input-container">
                    <div className="add-new-roll-selection-icon">
                      <RoleIcon />
                    </div>
                    <input
                      className="add-new-role-selection-input"
                      placeholder="Type Role Name"
                      value={roleName}
                      onChange={(e) => setroleName(e.target.value)}
                    ></input>
                  </div>
                </div>
                <div className="add-new-role-header-description">
                  <div className="add-new-role-desc-container-title">
                    <div className="add-new-role-desc-icon">
                      <DescriptionIcon />
                    </div>
                    <div className="add-new-role-desc-text">
                      Description
                      {/* <div className="required">*</div> */}
                    </div>
                  </div>
                  <div className="add-role-desc-cell">
                    <textarea
                      className="add-new-role-desc-text-input"
                      placeholder="Write description"
                      value={roledesc}
                      onChange={(e) => setroledesc(e.target.value)}
                    ></textarea>
                  </div>
                </div>
              </div>
              <div className="new-role-cell-body">
                <div className="new-role-cell-body-searchbar">
                  <div className="new-role-cell-search-cell">
                    <div className="new-role-cell-search-inner-container">
                      <input
                        className="new-role-cell-searchbar-input"
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      ></input>
                      <div className="new-role-cell-search-icon">
                        <SearchIcon />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="new-role-and-per-table">
                  <div className="add-new-roles-table-header-row">
                    <div className="add-role-cell-content-roll-desc">
                      <input
                        className="permission-checkbox"
                        type="checkbox"
                        checked={allChecked}
                        onChange={toggleAll}
                      ></input>
                    </div>
                    <div className="new-role-cell-content">Permission</div>
                  </div>
                  {filteredData.map((item, index) => (
                    <div className="new-role-table-row" key={index}>
                      <div className="new-role-checkbox-cell">
                        <input
                          type="checkbox"
                          checked={selected.includes(item.permissionID)}
                          onChange={() => toggleOne(item.permissionID)}
                        />
                      </div>
                      <div className="add-roll-cell-content-edit-roll-desc">
                        {item.permissionName}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="new-role-cell-footer">
                <div className="new-role-action-buttons">
                  <div
                    className="new-roll-save-changes-button"
                    onClick={() => {
                      handleCreateRoll();
                    }}
                  >
                    Create Role
                  </div>
                  <div
                    className="new-roll-cancel-changes-button"
                    onClick={() =>
                      navigate("/user-management", {
                        state: { active: "C" },
                      })
                    }
                  >
                    Cancel
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddRole;
